module.exports = __webpack_public_path__ + "img/participants-registration-completion-icon.d0a7c38b.svg";